import { useExperiencesContext } from '../../../experiences/Experiences';
import { useFacetContext } from '../../../../context/PlpContext';
import { usePlpViewType } from '../../../../hooks/usePlpViewType';

type ControlsData = {
  experiences: {
    isListViewEnabled: boolean;
    isProductCardSizeFlagOn: boolean;
    isTabletEnhancementsFlagOn: boolean;
  };
  facetContext: {
    isMoreFiltersButton: boolean;
    applied: {
      filterCombination: string;
    };
  };
  plpViewType: {
    hasPlpViewTypeSelection: boolean;
  };
};

export const useControlsData = (): ControlsData => {
  const {
    isListViewEnabled,
    isProductCardSizeFlagOn,
    isTabletEnhancementsFlagOn,
  } = useExperiencesContext();

  const { isPrimaryFacetInDiscoResponse: isMoreFiltersButton, applied } =
    useFacetContext();

  const { hasPlpViewTypeSelection } = usePlpViewType('useControlsData');

  return {
    experiences: {
      isListViewEnabled,
      isProductCardSizeFlagOn,
      isTabletEnhancementsFlagOn,
    },
    facetContext: {
      isMoreFiltersButton,
      applied,
    },
    plpViewType: {
      hasPlpViewTypeSelection,
    },
  };
};
